import { ResolveInfo as GraphQLResolveInfo } from './resolvers';
import { Context } from './resolvers';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type SOstoslistaAllergen = {
  __typename: 'Allergen';
  allergenTypeCode: Maybe<Scalars['String']>;
  allergenTypeText: Maybe<Scalars['String']>;
  levelOfContainmentCode: Maybe<Scalars['String']>;
};

export enum SOstoslistaCacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type SOstoslistaCoordinates = {
  __typename: 'Coordinates';
  lat: Scalars['String'];
  lon: Scalars['String'];
};

export type SOstoslistaCoordinatesInput = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type SOstoslistaCountry = {
  __typename: 'Country';
  code: Scalars['String'];
};

export type SOstoslistaCountryName = {
  __typename: 'CountryName';
  fi: Maybe<Scalars['String']>;
};

export type SOstoslistaCreateProductResolvedShoppingListItemInput = {
  collected: InputMaybe<Scalars['Boolean']>;
  commentForPicker: InputMaybe<Scalars['String']>;
  ean: Scalars['String'];
  isReplaceable: Scalars['Boolean'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  quantityUnit: Scalars['String'];
  sokId: Scalars['String'];
};

export type SOstoslistaCreateShoppingListItemInput = {
  collected: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export enum SOstoslistaDayLabel {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export enum SOstoslistaDomain {
  Abc = 'ABC',
  Eprisma = 'EPRISMA',
  Herkku = 'HERKKU',
  SKaupat = 'S_KAUPAT'
}

export type SOstoslistaHierarchyPathItem = {
  __typename: 'HierarchyPathItem';
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type SOstoslistaIdObject = {
  __typename: 'IDObject';
  id: Scalars['ID'];
};

export type SOstoslistaIShoppingListItem = {
  collected: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shoppingListId: Scalars['String'];
};

export type SOstoslistaInsertByEanInput = {
  ean: Scalars['String'];
  quantity: Scalars['Float'];
};

export type SOstoslistaLocalizableText = {
  __typename: 'LocalizableText';
  default: Scalars['String'];
  en: Maybe<Scalars['String']>;
  et: Maybe<Scalars['String']>;
  fi: Maybe<Scalars['String']>;
  sv: Maybe<Scalars['String']>;
};

export type SOstoslistaLocalizedText = {
  __typename: 'LocalizedText';
  en: Maybe<Scalars['String']>;
  et: Maybe<Scalars['String']>;
  fi: Maybe<Scalars['String']>;
  sv: Maybe<Scalars['String']>;
};

export type SOstoslistaMunicipality = {
  __typename: 'Municipality';
  code: Scalars['String'];
  name: Maybe<SOstoslistaLocalizableText>;
};

export type SOstoslistaMutation = {
  __typename: 'Mutation';
  batchDeleteShoppingListItem: SOstoslistaShoppingList;
  batchInsertByEan: SOstoslistaShoppingList;
  batchInsertShoppingListItem: SOstoslistaShoppingList;
  batchUpdateShoppingListItem: SOstoslistaShoppingList;
  claimSharedShoppingList: SOstoslistaShoppingList;
  createProductResolvedShoppingListItem: SOstoslistaShoppingList;
  createShoppingList: Maybe<SOstoslistaShoppingList>;
  createShoppingListFromRecipe: Maybe<SOstoslistaShoppingList>;
  createShoppingListItem: SOstoslistaShoppingList;
  deleteShoppingList: SOstoslistaIdObject;
  deleteShoppingListItem: SOstoslistaShoppingList;
  duplicateShoppingList: SOstoslistaShoppingList;
  generateShoppingListShareLink: SOstoslistaSharedShoppingListLink;
  insertRecipeProductsToList: SOstoslistaShoppingList;
  resolveShoppingListItemProduct: SOstoslistaShoppingList;
  setListItemsReplaceability: SOstoslistaShoppingList;
  unresolveShoppingListItemProduct: SOstoslistaShoppingList;
  updateShoppingList: SOstoslistaShoppingList;
  updateShoppingListItem: SOstoslistaProductResolvedShoppingListItem | SOstoslistaShoppingListItem;
};


export type SOstoslistaMutationBatchDeleteShoppingListItemArgs = {
  ids: Array<Scalars['ID']>;
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationBatchInsertByEanArgs = {
  items: Array<SOstoslistaInsertByEanInput>;
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationBatchInsertShoppingListItemArgs = {
  items: InputMaybe<Array<SOstoslistaCreateShoppingListItemInput>>;
  productResolvedItems: InputMaybe<Array<SOstoslistaCreateProductResolvedShoppingListItemInput>>;
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationBatchUpdateShoppingListItemArgs = {
  ids: Array<Scalars['ID']>;
  items: Array<SOstoslistaUpdateShoppingListItemInput>;
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationClaimSharedShoppingListArgs = {
  linkId: Scalars['ID'];
};


export type SOstoslistaMutationCreateProductResolvedShoppingListItemArgs = {
  item: SOstoslistaCreateProductResolvedShoppingListItemInput;
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationCreateShoppingListArgs = {
  items: InputMaybe<Array<SOstoslistaCreateShoppingListItemInput>>;
  name: Scalars['String'];
  productResolvedItems: InputMaybe<Array<SOstoslistaCreateProductResolvedShoppingListItemInput>>;
  storeId: InputMaybe<Scalars['String']>;
};


export type SOstoslistaMutationCreateShoppingListFromRecipeArgs = {
  name: Scalars['String'];
  recipeId: Scalars['String'];
  storeId: InputMaybe<Scalars['String']>;
};


export type SOstoslistaMutationCreateShoppingListItemArgs = {
  item: SOstoslistaCreateShoppingListItemInput;
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationDeleteShoppingListArgs = {
  id: Scalars['ID'];
};


export type SOstoslistaMutationDeleteShoppingListItemArgs = {
  id: Scalars['ID'];
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationDuplicateShoppingListArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
  storeId: InputMaybe<Scalars['String']>;
};


export type SOstoslistaMutationGenerateShoppingListShareLinkArgs = {
  id: Scalars['ID'];
  permissions: Array<SOstoslistaPermission>;
  validForHours: InputMaybe<Scalars['Int']>;
};


export type SOstoslistaMutationInsertRecipeProductsToListArgs = {
  recipeId: Scalars['String'];
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationResolveShoppingListItemProductArgs = {
  id: Scalars['ID'];
  shoppingListId: Scalars['ID'];
  sokId: Scalars['String'];
};


export type SOstoslistaMutationSetListItemsReplaceabilityArgs = {
  isReplaceable: Scalars['Boolean'];
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationUnresolveShoppingListItemProductArgs = {
  id: Scalars['ID'];
  shoppingListId: Scalars['ID'];
};


export type SOstoslistaMutationUpdateShoppingListArgs = {
  id: Scalars['ID'];
  name: InputMaybe<Scalars['String']>;
  storeId: InputMaybe<Scalars['String']>;
};


export type SOstoslistaMutationUpdateShoppingListItemArgs = {
  id: Scalars['ID'];
  item: SOstoslistaUpdateShoppingListItemInput;
  shoppingListId: Scalars['ID'];
};

export type SOstoslistaNavigation = {
  __typename: 'Navigation';
  navigation: Maybe<Array<SOstoslistaNavigationItem>>;
};

export type SOstoslistaNavigationItem = {
  __typename: 'NavigationItem';
  children: Maybe<Array<SOstoslistaNavigationItem>>;
  hidden: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['String']>;
  itemCount: Maybe<Scalars['Int']>;
  name: Maybe<Scalars['String']>;
  sequence: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
};

export type SOstoslistaNutrient = {
  __typename: 'Nutrient';
  kcal: Maybe<Scalars['Float']>;
  kj: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  ri: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum SOstoslistaPaymentMethod {
  CardPayment = 'CARD_PAYMENT',
  Invoice = 'INVOICE',
  OnDelivery = 'ON_DELIVERY'
}

export enum SOstoslistaPermission {
  Read = 'READ',
  Share = 'SHARE',
  Write = 'WRITE'
}

export type SOstoslistaProduct = {
  __typename: 'Product';
  _lemmasAliasName: Maybe<Scalars['String']>;
  _lemmasDescription: Maybe<Scalars['String']>;
  _lemmasHierarchyLeaf: Maybe<Scalars['String']>;
  _lemmasName: Maybe<Scalars['String']>;
  allergens: Maybe<Array<SOstoslistaAllergen>>;
  approxPrice: Maybe<Scalars['Boolean']>;
  available: Scalars['Boolean'];
  basicQuantityUnit: Maybe<Scalars['String']>;
  brandName: Maybe<Scalars['String']>;
  category: Maybe<Scalars['String']>;
  comparisonPrice: Maybe<Scalars['Float']>;
  comparisonUnit: Maybe<Scalars['String']>;
  countryName: Maybe<SOstoslistaCountryName>;
  depositPrice: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  ean: Scalars['String'];
  frozen: Maybe<Scalars['Boolean']>;
  hierarchyPath: Maybe<Array<SOstoslistaHierarchyPathItem>>;
  id: Scalars['ID'];
  ingredientStatement: Maybe<Scalars['String']>;
  isAgeLimitedByAlcohol: Maybe<Scalars['Boolean']>;
  isGlobalFallback: Maybe<Scalars['Boolean']>;
  location: Maybe<SOstoslistaProductLocation>;
  measurement: Maybe<SOstoslistaProductMeasurement>;
  name: Scalars['String'];
  nutrients: Maybe<Array<SOstoslistaNutrient>>;
  packagingLabelCodes: Maybe<Array<Scalars['String']>>;
  packagingLabels: Maybe<Array<Scalars['String']>>;
  price: Maybe<Scalars['Float']>;
  priceUnit: Scalars['String'];
  pricing: Maybe<SOstoslistaProductPricing>;
  quantityMultiplier: Maybe<Scalars['Float']>;
  storeId: Maybe<Scalars['ID']>;
  storeInfo: Maybe<Array<SOstoslistaStoreInfo>>;
  supplierName: Maybe<Scalars['String']>;
};


export type SOstoslistaProductStoreInfoArgs = {
  pageSize: InputMaybe<Scalars['Int']>;
  userLocation: InputMaybe<SOstoslistaCoordinatesInput>;
};

export enum SOstoslistaProductDataSource {
  SKaupat = 'S_KAUPAT',
  SOstoslista = 'S_OSTOSLISTA'
}

export type SOstoslistaProductLocation = {
  __typename: 'ProductLocation';
  aisle: Maybe<Scalars['String']>;
  floor: Scalars['Int'];
  label: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type SOstoslistaProductMeasurement = {
  __typename: 'ProductMeasurement';
  grossWeight: Maybe<Scalars['Float']>;
  grossWeightUnit: Maybe<Scalars['String']>;
  netWeight: Maybe<Scalars['Float']>;
  netWeightUnit: Maybe<Scalars['String']>;
  pceApproxWeight: Maybe<Scalars['Float']>;
};

export type SOstoslistaProductPricing = {
  __typename: 'ProductPricing';
  campaignPrice: Maybe<Scalars['Float']>;
  campaignPriceValidUntil: Maybe<Scalars['String']>;
  comparisonPrice: Scalars['Float'];
  currentPrice: Scalars['Float'];
  depositPrice: Maybe<Scalars['Float']>;
  lowest30DayPrice: Maybe<Scalars['Float']>;
  regularPrice: Scalars['Float'];
};

export type SOstoslistaProductResolvedShoppingListItem = SOstoslistaIShoppingListItem & {
  __typename: 'ProductResolvedShoppingListItem';
  collected: Maybe<Scalars['Boolean']>;
  commentForPicker: Maybe<Scalars['String']>;
  ean: Scalars['String'];
  id: Scalars['ID'];
  isReplaceable: Scalars['Boolean'];
  name: Scalars['String'];
  product: Maybe<SOstoslistaProduct>;
  quantity: Scalars['Float'];
  quantityUnit: Scalars['String'];
  shoppingListId: Scalars['String'];
  sokId: Scalars['String'];
};


export type SOstoslistaProductResolvedShoppingListItemProductArgs = {
  dataSource: InputMaybe<SOstoslistaProductDataSource>;
  storeId: InputMaybe<Scalars['String']>;
};

export type SOstoslistaProductSearchResult = {
  __typename: 'ProductSearchResult';
  items: Array<SOstoslistaProduct>;
  maybeHasMore: Scalars['Boolean'];
};

export type SOstoslistaQuery = {
  __typename: 'Query';
  anonymousUserToken: Scalars['String'];
  navigation: Maybe<Array<SOstoslistaNavigationItem>>;
  product: SOstoslistaProduct;
  productByEan: SOstoslistaProduct;
  products: SOstoslistaProductSearchResult;
  recipes: SOstoslistaSearchRecipesResponse;
  shoppingList: SOstoslistaShoppingList;
  shoppingLists: Array<SOstoslistaShoppingList>;
  store: SOstoslistaStoreInfo;
  stores: SOstoslistaSearchStoresResponse;
  user: Maybe<SOstoslistaUser>;
};


export type SOstoslistaQueryNavigationArgs = {
  storeId: Scalars['ID'];
};


export type SOstoslistaQueryProductArgs = {
  globalAssortment: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  storeId: InputMaybe<Scalars['ID']>;
};


export type SOstoslistaQueryProductByEanArgs = {
  ean: Scalars['ID'];
  globalAssortment: InputMaybe<Scalars['Boolean']>;
  storeId: InputMaybe<Scalars['ID']>;
};


export type SOstoslistaQueryProductsArgs = {
  eans: InputMaybe<Array<Scalars['String']>>;
  excludedCdts: InputMaybe<Array<Scalars['String']>>;
  from: InputMaybe<Scalars['Int']>;
  globalAssortment: InputMaybe<Scalars['Boolean']>;
  ids: InputMaybe<Array<Scalars['ID']>>;
  includedCdts: InputMaybe<Array<Scalars['String']>>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  storeId: InputMaybe<Scalars['ID']>;
};


export type SOstoslistaQueryRecipesArgs = {
  from: InputMaybe<Scalars['Int']>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type SOstoslistaQueryShoppingListArgs = {
  id: Scalars['ID'];
};


export type SOstoslistaQueryStoreArgs = {
  id: Scalars['ID'];
};


export type SOstoslistaQueryStoresArgs = {
  brand: InputMaybe<SOstoslistaStoreBrand>;
  cursor: InputMaybe<Scalars['String']>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};

export type SOstoslistaRecipe = {
  __typename: 'Recipe';
  id: Scalars['ID'];
  imageUrl: Maybe<Scalars['String']>;
  notes: Maybe<Array<SOstoslistaRecipeNote>>;
  products: Array<SOstoslistaRecipeProduct>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type SOstoslistaRecipeNote = {
  __typename: 'RecipeNote';
  content: Scalars['String'];
};

export type SOstoslistaRecipeProduct = {
  __typename: 'RecipeProduct';
  ean: Scalars['String'];
  quantity: Scalars['Float'];
};

export type SOstoslistaSearchRecipesResponse = {
  __typename: 'SearchRecipesResponse';
  items: Array<SOstoslistaRecipe>;
  maybeHasMore: Scalars['Boolean'];
};

export type SOstoslistaSearchStoresResponse = {
  __typename: 'SearchStoresResponse';
  cursor: Maybe<Scalars['String']>;
  maybeHasMore: Maybe<Scalars['Boolean']>;
  stores: Array<SOstoslistaStoreInfo>;
  totalCount: Scalars['Int'];
};

export type SOstoslistaSharedShoppingListLink = {
  __typename: 'SharedShoppingListLink';
  id: Scalars['String'];
};

export type SOstoslistaShoppingList = {
  __typename: 'ShoppingList';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  items: Array<SOstoslistaProductResolvedShoppingListItem | SOstoslistaShoppingListItem>;
  modifiedAt: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<SOstoslistaPermission>;
  shared: Scalars['Boolean'];
  storeId: Maybe<Scalars['String']>;
};

export type SOstoslistaShoppingListItem = SOstoslistaIShoppingListItem & {
  __typename: 'ShoppingListItem';
  collected: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shoppingListId: Scalars['String'];
};

export type SOstoslistaStoreAddress = {
  __typename: 'StoreAddress';
  country: Maybe<SOstoslistaCountry>;
  municipality: SOstoslistaMunicipality;
  postcode: Scalars['String'];
  postcodeName: Maybe<SOstoslistaLocalizableText>;
  street: SOstoslistaLocalizableText;
};

export enum SOstoslistaStoreBrand {
  Abc = 'ABC',
  Alepa = 'ALEPA',
  Herkku = 'HERKKU',
  MestarinHerkku = 'MESTARIN_HERKKU',
  Prisma = 'PRISMA',
  Sale = 'SALE',
  SokosHerkku = 'SOKOS_HERKKU',
  SMarket = 'S_MARKET'
}

export type SOstoslistaStoreContactInfo = {
  __typename: 'StoreContactInfo';
  email: Maybe<Scalars['String']>;
  phoneNumber: Maybe<SOstoslistaStorePhoneNumber>;
};

export type SOstoslistaStoreDayOpeningTime = {
  __typename: 'StoreDayOpeningTime';
  date: Scalars['String'];
  day: SOstoslistaDayLabel;
  exceptional: Maybe<Scalars['Boolean']>;
  message: Maybe<SOstoslistaLocalizedText>;
  mode: SOstoslistaStoreOpeningTimeRangeLabel;
  ranges: Maybe<Array<SOstoslistaStoreOpeningTimeRange>>;
};

export type SOstoslistaStoreFeedback = {
  __typename: 'StoreFeedback';
  url: Maybe<SOstoslistaLocalizableText>;
};

export type SOstoslistaStoreInfo = {
  __typename: 'StoreInfo';
  availablePaymentMethods: Maybe<Array<SOstoslistaPaymentMethod>>;
  brand: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  contactInfo: Maybe<SOstoslistaStoreContactInfo>;
  distance: Maybe<Scalars['Float']>;
  domains: Array<SOstoslistaDomain>;
  feedback: Maybe<SOstoslistaStoreFeedback>;
  id: Scalars['ID'];
  location: Maybe<SOstoslistaStoreLocation>;
  name: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  services: Maybe<Array<SOstoslistaStoreService>>;
  shortName: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  weeklyOpeningHours: Maybe<Array<SOstoslistaStoreWeeklyOpeningTime>>;
};

export type SOstoslistaStoreLocation = {
  __typename: 'StoreLocation';
  address: Maybe<SOstoslistaStoreAddress>;
  coordinates: Maybe<SOstoslistaCoordinates>;
};

export type SOstoslistaStoreOpeningTimeRange = {
  __typename: 'StoreOpeningTimeRange';
  close: Scalars['String'];
  closeOnSameDay: Maybe<Scalars['Boolean']>;
  open: Scalars['String'];
};

export enum SOstoslistaStoreOpeningTimeRangeLabel {
  AllDay = 'ALL_DAY',
  ByReservation = 'BY_RESERVATION',
  Closed = 'CLOSED',
  Range = 'RANGE'
}

export type SOstoslistaStorePhoneNumber = {
  __typename: 'StorePhoneNumber';
  callCharge: Maybe<SOstoslistaLocalizableText>;
  callChargeGroup: Maybe<Scalars['String']>;
  number: Scalars['String'];
};

export type SOstoslistaStoreService = {
  __typename: 'StoreService';
  code: Scalars['String'];
  name: Maybe<SOstoslistaLocalizableText>;
};

export type SOstoslistaStoreWeeklyOpeningTime = {
  __typename: 'StoreWeeklyOpeningTime';
  openingTimes: Array<SOstoslistaStoreDayOpeningTime>;
  weekNumber: Scalars['Int'];
};

export type SOstoslistaSubscription = {
  __typename: 'Subscription';
  updatedShoppingList: Maybe<SOstoslistaShoppingList>;
  updatedShoppingListItem: Maybe<SOstoslistaProductResolvedShoppingListItem | SOstoslistaShoppingListItem>;
};


export type SOstoslistaSubscriptionUpdatedShoppingListArgs = {
  id: Scalars['ID'];
};


export type SOstoslistaSubscriptionUpdatedShoppingListItemArgs = {
  shoppingListId: Scalars['String'];
};

export type SOstoslistaUpdateShoppingListItemInput = {
  collected: InputMaybe<Scalars['Boolean']>;
  commentForPicker: InputMaybe<Scalars['String']>;
  isReplaceable: InputMaybe<Scalars['Boolean']>;
  name: InputMaybe<Scalars['String']>;
  quantity: InputMaybe<Scalars['Float']>;
};

export type SOstoslistaUser = {
  __typename: 'User';
  id: Scalars['String'];
  name: Maybe<Scalars['String']>;
  type: SOstoslistaUserType;
};

export enum SOstoslistaUserType {
  AnonymousUser = 'ANONYMOUS_USER'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;

export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info?: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info?: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type SOstoslistaResolversTypes = {
  Allergen: ResolverTypeWrapper<SOstoslistaAllergen>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  CacheControlScope: SOstoslistaCacheControlScope;
  Coordinates: ResolverTypeWrapper<SOstoslistaCoordinates>;
  CoordinatesInput: SOstoslistaCoordinatesInput;
  Country: ResolverTypeWrapper<SOstoslistaCountry>;
  CountryName: ResolverTypeWrapper<SOstoslistaCountryName>;
  CreateProductResolvedShoppingListItemInput: SOstoslistaCreateProductResolvedShoppingListItemInput;
  CreateShoppingListItemInput: SOstoslistaCreateShoppingListItemInput;
  DayLabel: SOstoslistaDayLabel;
  Domain: SOstoslistaDomain;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  HierarchyPathItem: ResolverTypeWrapper<SOstoslistaHierarchyPathItem>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IDObject: ResolverTypeWrapper<SOstoslistaIdObject>;
  IShoppingListItem: SOstoslistaResolversTypes['ProductResolvedShoppingListItem'] | SOstoslistaResolversTypes['ShoppingListItem'];
  InsertByEanInput: SOstoslistaInsertByEanInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  LocalizableText: ResolverTypeWrapper<SOstoslistaLocalizableText>;
  LocalizedText: ResolverTypeWrapper<SOstoslistaLocalizedText>;
  Municipality: ResolverTypeWrapper<SOstoslistaMunicipality>;
  Mutation: ResolverTypeWrapper<{}>;
  Navigation: ResolverTypeWrapper<SOstoslistaNavigation>;
  NavigationItem: ResolverTypeWrapper<SOstoslistaNavigationItem>;
  Nutrient: ResolverTypeWrapper<SOstoslistaNutrient>;
  PaymentMethod: SOstoslistaPaymentMethod;
  Permission: SOstoslistaPermission;
  Product: ResolverTypeWrapper<SOstoslistaProduct>;
  ProductDataSource: SOstoslistaProductDataSource;
  ProductLocation: ResolverTypeWrapper<SOstoslistaProductLocation>;
  ProductMeasurement: ResolverTypeWrapper<SOstoslistaProductMeasurement>;
  ProductPricing: ResolverTypeWrapper<SOstoslistaProductPricing>;
  ProductResolvedShoppingListItem: ResolverTypeWrapper<SOstoslistaProductResolvedShoppingListItem>;
  ProductSearchResult: ResolverTypeWrapper<SOstoslistaProductSearchResult>;
  Query: ResolverTypeWrapper<{}>;
  Recipe: ResolverTypeWrapper<SOstoslistaRecipe>;
  RecipeNote: ResolverTypeWrapper<SOstoslistaRecipeNote>;
  RecipeProduct: ResolverTypeWrapper<SOstoslistaRecipeProduct>;
  SearchRecipesResponse: ResolverTypeWrapper<SOstoslistaSearchRecipesResponse>;
  SearchStoresResponse: ResolverTypeWrapper<SOstoslistaSearchStoresResponse>;
  SharedShoppingListLink: ResolverTypeWrapper<SOstoslistaSharedShoppingListLink>;
  ShoppingList: ResolverTypeWrapper<SOstoslistaShoppingList>;
  ShoppingListItem: ResolverTypeWrapper<SOstoslistaShoppingListItem>;
  StoreAddress: ResolverTypeWrapper<SOstoslistaStoreAddress>;
  StoreBrand: SOstoslistaStoreBrand;
  StoreContactInfo: ResolverTypeWrapper<SOstoslistaStoreContactInfo>;
  StoreDayOpeningTime: ResolverTypeWrapper<SOstoslistaStoreDayOpeningTime>;
  StoreFeedback: ResolverTypeWrapper<SOstoslistaStoreFeedback>;
  StoreInfo: ResolverTypeWrapper<SOstoslistaStoreInfo>;
  StoreLocation: ResolverTypeWrapper<SOstoslistaStoreLocation>;
  StoreOpeningTimeRange: ResolverTypeWrapper<SOstoslistaStoreOpeningTimeRange>;
  StoreOpeningTimeRangeLabel: SOstoslistaStoreOpeningTimeRangeLabel;
  StorePhoneNumber: ResolverTypeWrapper<SOstoslistaStorePhoneNumber>;
  StoreService: ResolverTypeWrapper<SOstoslistaStoreService>;
  StoreWeeklyOpeningTime: ResolverTypeWrapper<SOstoslistaStoreWeeklyOpeningTime>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Subscription: ResolverTypeWrapper<{}>;
  UpdateShoppingListItemInput: SOstoslistaUpdateShoppingListItemInput;
  User: ResolverTypeWrapper<SOstoslistaUser>;
  UserType: SOstoslistaUserType;
};

/** Mapping between all available schema types and the resolvers parents */
export type SOstoslistaResolversParentTypes = {
  Allergen: SOstoslistaAllergen;
  Boolean: Scalars['Boolean'];
  Coordinates: SOstoslistaCoordinates;
  CoordinatesInput: SOstoslistaCoordinatesInput;
  Country: SOstoslistaCountry;
  CountryName: SOstoslistaCountryName;
  CreateProductResolvedShoppingListItemInput: SOstoslistaCreateProductResolvedShoppingListItemInput;
  CreateShoppingListItemInput: SOstoslistaCreateShoppingListItemInput;
  Float: Scalars['Float'];
  HierarchyPathItem: SOstoslistaHierarchyPathItem;
  ID: Scalars['ID'];
  IDObject: SOstoslistaIdObject;
  IShoppingListItem: SOstoslistaResolversParentTypes['ProductResolvedShoppingListItem'] | SOstoslistaResolversParentTypes['ShoppingListItem'];
  InsertByEanInput: SOstoslistaInsertByEanInput;
  Int: Scalars['Int'];
  LocalizableText: SOstoslistaLocalizableText;
  LocalizedText: SOstoslistaLocalizedText;
  Municipality: SOstoslistaMunicipality;
  Mutation: {};
  Navigation: SOstoslistaNavigation;
  NavigationItem: SOstoslistaNavigationItem;
  Nutrient: SOstoslistaNutrient;
  Product: SOstoslistaProduct;
  ProductLocation: SOstoslistaProductLocation;
  ProductMeasurement: SOstoslistaProductMeasurement;
  ProductPricing: SOstoslistaProductPricing;
  ProductResolvedShoppingListItem: SOstoslistaProductResolvedShoppingListItem;
  ProductSearchResult: SOstoslistaProductSearchResult;
  Query: {};
  Recipe: SOstoslistaRecipe;
  RecipeNote: SOstoslistaRecipeNote;
  RecipeProduct: SOstoslistaRecipeProduct;
  SearchRecipesResponse: SOstoslistaSearchRecipesResponse;
  SearchStoresResponse: SOstoslistaSearchStoresResponse;
  SharedShoppingListLink: SOstoslistaSharedShoppingListLink;
  ShoppingList: SOstoslistaShoppingList;
  ShoppingListItem: SOstoslistaShoppingListItem;
  StoreAddress: SOstoslistaStoreAddress;
  StoreContactInfo: SOstoslistaStoreContactInfo;
  StoreDayOpeningTime: SOstoslistaStoreDayOpeningTime;
  StoreFeedback: SOstoslistaStoreFeedback;
  StoreInfo: SOstoslistaStoreInfo;
  StoreLocation: SOstoslistaStoreLocation;
  StoreOpeningTimeRange: SOstoslistaStoreOpeningTimeRange;
  StorePhoneNumber: SOstoslistaStorePhoneNumber;
  StoreService: SOstoslistaStoreService;
  StoreWeeklyOpeningTime: SOstoslistaStoreWeeklyOpeningTime;
  String: Scalars['String'];
  Subscription: {};
  UpdateShoppingListItemInput: SOstoslistaUpdateShoppingListItemInput;
  User: SOstoslistaUser;
};

export type SOstoslistaAws_Api_KeyDirectiveArgs = { };

export type SOstoslistaAws_Api_KeyDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_Api_KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_AuthDirectiveArgs = {
  cognito_groups: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SOstoslistaAws_AuthDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_Cognito_User_PoolsDirectiveArgs = {
  cognito_groups: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SOstoslistaAws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_IamDirectiveArgs = { };

export type SOstoslistaAws_IamDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_LambdaDirectiveArgs = { };

export type SOstoslistaAws_LambdaDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_LambdaDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_OidcDirectiveArgs = { };

export type SOstoslistaAws_OidcDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_OidcDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_PublishDirectiveArgs = {
  subscriptions: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SOstoslistaAws_PublishDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_PublishDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAws_SubscribeDirectiveArgs = {
  mutations: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SOstoslistaAws_SubscribeDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaAws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaDeferDirectiveArgs = { };

export type SOstoslistaDeferDirectiveResolver<Result, Parent, ContextType = Context, Args = SOstoslistaDeferDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SOstoslistaAllergenResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Allergen'] = SOstoslistaResolversParentTypes['Allergen']> = {
  allergenTypeCode: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  allergenTypeText: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  levelOfContainmentCode: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaCoordinatesResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Coordinates'] = SOstoslistaResolversParentTypes['Coordinates']> = {
  lat: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  lon: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaCountryResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Country'] = SOstoslistaResolversParentTypes['Country']> = {
  code: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaCountryNameResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['CountryName'] = SOstoslistaResolversParentTypes['CountryName']> = {
  fi: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaHierarchyPathItemResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['HierarchyPathItem'] = SOstoslistaResolversParentTypes['HierarchyPathItem']> = {
  hidden: Resolver<SOstoslistaResolversTypes['Boolean'], ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  slug: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaIdObjectResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['IDObject'] = SOstoslistaResolversParentTypes['IDObject']> = {
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaIShoppingListItemResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['IShoppingListItem'] = SOstoslistaResolversParentTypes['IShoppingListItem']> = {
  __resolveType: TypeResolveFn<'ProductResolvedShoppingListItem' | 'ShoppingListItem', ParentType, ContextType>;
  collected: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  name: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  shoppingListId: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
};

export type SOstoslistaLocalizableTextResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['LocalizableText'] = SOstoslistaResolversParentTypes['LocalizableText']> = {
  default: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  en: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  et: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  fi: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  sv: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaLocalizedTextResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['LocalizedText'] = SOstoslistaResolversParentTypes['LocalizedText']> = {
  en: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  et: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  fi: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  sv: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaMunicipalityResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Municipality'] = SOstoslistaResolversParentTypes['Municipality']> = {
  code: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['LocalizableText']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaMutationResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Mutation'] = SOstoslistaResolversParentTypes['Mutation']> = {
  batchDeleteShoppingListItem: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationBatchDeleteShoppingListItemArgs, 'ids' | 'shoppingListId'>>;
  batchInsertByEan: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationBatchInsertByEanArgs, 'items' | 'shoppingListId'>>;
  batchInsertShoppingListItem: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationBatchInsertShoppingListItemArgs, 'shoppingListId'>>;
  batchUpdateShoppingListItem: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationBatchUpdateShoppingListItemArgs, 'ids' | 'items' | 'shoppingListId'>>;
  claimSharedShoppingList: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationClaimSharedShoppingListArgs, 'linkId'>>;
  createProductResolvedShoppingListItem: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationCreateProductResolvedShoppingListItemArgs, 'item' | 'shoppingListId'>>;
  createShoppingList: Resolver<Maybe<SOstoslistaResolversTypes['ShoppingList']>, ParentType, ContextType, RequireFields<SOstoslistaMutationCreateShoppingListArgs, 'name'>>;
  createShoppingListFromRecipe: Resolver<Maybe<SOstoslistaResolversTypes['ShoppingList']>, ParentType, ContextType, RequireFields<SOstoslistaMutationCreateShoppingListFromRecipeArgs, 'name' | 'recipeId'>>;
  createShoppingListItem: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationCreateShoppingListItemArgs, 'item' | 'shoppingListId'>>;
  deleteShoppingList: Resolver<SOstoslistaResolversTypes['IDObject'], ParentType, ContextType, RequireFields<SOstoslistaMutationDeleteShoppingListArgs, 'id'>>;
  deleteShoppingListItem: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationDeleteShoppingListItemArgs, 'id' | 'shoppingListId'>>;
  duplicateShoppingList: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationDuplicateShoppingListArgs, 'id' | 'name'>>;
  generateShoppingListShareLink: Resolver<SOstoslistaResolversTypes['SharedShoppingListLink'], ParentType, ContextType, RequireFields<SOstoslistaMutationGenerateShoppingListShareLinkArgs, 'id' | 'permissions'>>;
  insertRecipeProductsToList: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationInsertRecipeProductsToListArgs, 'recipeId' | 'shoppingListId'>>;
  resolveShoppingListItemProduct: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationResolveShoppingListItemProductArgs, 'id' | 'shoppingListId' | 'sokId'>>;
  setListItemsReplaceability: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationSetListItemsReplaceabilityArgs, 'isReplaceable' | 'shoppingListId'>>;
  unresolveShoppingListItemProduct: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationUnresolveShoppingListItemProductArgs, 'id' | 'shoppingListId'>>;
  updateShoppingList: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaMutationUpdateShoppingListArgs, 'id'>>;
  updateShoppingListItem: Resolver<SOstoslistaResolversTypes['IShoppingListItem'], ParentType, ContextType, RequireFields<SOstoslistaMutationUpdateShoppingListItemArgs, 'id' | 'item' | 'shoppingListId'>>;
};

export type SOstoslistaNavigationResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Navigation'] = SOstoslistaResolversParentTypes['Navigation']> = {
  navigation: Resolver<Maybe<Array<SOstoslistaResolversTypes['NavigationItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaNavigationItemResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['NavigationItem'] = SOstoslistaResolversParentTypes['NavigationItem']> = {
  children: Resolver<Maybe<Array<SOstoslistaResolversTypes['NavigationItem']>>, ParentType, ContextType>;
  hidden: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  id: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  itemCount: Resolver<Maybe<SOstoslistaResolversTypes['Int']>, ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  sequence: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  slug: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  type: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaNutrientResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Nutrient'] = SOstoslistaResolversParentTypes['Nutrient']> = {
  kcal: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  kj: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  ri: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  value: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaProductResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Product'] = SOstoslistaResolversParentTypes['Product']> = {
  _lemmasAliasName: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  _lemmasDescription: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  _lemmasHierarchyLeaf: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  _lemmasName: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  allergens: Resolver<Maybe<Array<SOstoslistaResolversTypes['Allergen']>>, ParentType, ContextType>;
  approxPrice: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  available: Resolver<SOstoslistaResolversTypes['Boolean'], ParentType, ContextType>;
  basicQuantityUnit: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  brandName: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  category: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  comparisonPrice: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  comparisonUnit: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  countryName: Resolver<Maybe<SOstoslistaResolversTypes['CountryName']>, ParentType, ContextType>;
  depositPrice: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  description: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  ean: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  frozen: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  hierarchyPath: Resolver<Maybe<Array<SOstoslistaResolversTypes['HierarchyPathItem']>>, ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  ingredientStatement: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  isAgeLimitedByAlcohol: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  isGlobalFallback: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  location: Resolver<Maybe<SOstoslistaResolversTypes['ProductLocation']>, ParentType, ContextType>;
  measurement: Resolver<Maybe<SOstoslistaResolversTypes['ProductMeasurement']>, ParentType, ContextType>;
  name: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  nutrients: Resolver<Maybe<Array<SOstoslistaResolversTypes['Nutrient']>>, ParentType, ContextType>;
  packagingLabelCodes: Resolver<Maybe<Array<SOstoslistaResolversTypes['String']>>, ParentType, ContextType>;
  packagingLabels: Resolver<Maybe<Array<SOstoslistaResolversTypes['String']>>, ParentType, ContextType>;
  price: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  priceUnit: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  pricing: Resolver<Maybe<SOstoslistaResolversTypes['ProductPricing']>, ParentType, ContextType>;
  quantityMultiplier: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  storeId: Resolver<Maybe<SOstoslistaResolversTypes['ID']>, ParentType, ContextType>;
  storeInfo: Resolver<Maybe<Array<SOstoslistaResolversTypes['StoreInfo']>>, ParentType, ContextType, Partial<SOstoslistaProductStoreInfoArgs>>;
  supplierName: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaProductLocationResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ProductLocation'] = SOstoslistaResolversParentTypes['ProductLocation']> = {
  aisle: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  floor: Resolver<SOstoslistaResolversTypes['Int'], ParentType, ContextType>;
  label: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaProductMeasurementResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ProductMeasurement'] = SOstoslistaResolversParentTypes['ProductMeasurement']> = {
  grossWeight: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  grossWeightUnit: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  netWeight: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  netWeightUnit: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  pceApproxWeight: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaProductPricingResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ProductPricing'] = SOstoslistaResolversParentTypes['ProductPricing']> = {
  campaignPrice: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  campaignPriceValidUntil: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  comparisonPrice: Resolver<SOstoslistaResolversTypes['Float'], ParentType, ContextType>;
  currentPrice: Resolver<SOstoslistaResolversTypes['Float'], ParentType, ContextType>;
  depositPrice: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  lowest30DayPrice: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  regularPrice: Resolver<SOstoslistaResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaProductResolvedShoppingListItemResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ProductResolvedShoppingListItem'] = SOstoslistaResolversParentTypes['ProductResolvedShoppingListItem']> = {
  collected: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  commentForPicker: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  ean: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  isReplaceable: Resolver<SOstoslistaResolversTypes['Boolean'], ParentType, ContextType>;
  name: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  product: Resolver<Maybe<SOstoslistaResolversTypes['Product']>, ParentType, ContextType, Partial<SOstoslistaProductResolvedShoppingListItemProductArgs>>;
  quantity: Resolver<SOstoslistaResolversTypes['Float'], ParentType, ContextType>;
  quantityUnit: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  shoppingListId: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  sokId: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaProductSearchResultResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ProductSearchResult'] = SOstoslistaResolversParentTypes['ProductSearchResult']> = {
  items: Resolver<Array<SOstoslistaResolversTypes['Product']>, ParentType, ContextType>;
  maybeHasMore: Resolver<SOstoslistaResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaQueryResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Query'] = SOstoslistaResolversParentTypes['Query']> = {
  anonymousUserToken: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  navigation: Resolver<Maybe<Array<SOstoslistaResolversTypes['NavigationItem']>>, ParentType, ContextType, RequireFields<SOstoslistaQueryNavigationArgs, 'storeId'>>;
  product: Resolver<SOstoslistaResolversTypes['Product'], ParentType, ContextType, RequireFields<SOstoslistaQueryProductArgs, 'id'>>;
  productByEan: Resolver<SOstoslistaResolversTypes['Product'], ParentType, ContextType, RequireFields<SOstoslistaQueryProductByEanArgs, 'ean'>>;
  products: Resolver<SOstoslistaResolversTypes['ProductSearchResult'], ParentType, ContextType, Partial<SOstoslistaQueryProductsArgs>>;
  recipes: Resolver<SOstoslistaResolversTypes['SearchRecipesResponse'], ParentType, ContextType, RequireFields<SOstoslistaQueryRecipesArgs, 'query'>>;
  shoppingList: Resolver<SOstoslistaResolversTypes['ShoppingList'], ParentType, ContextType, RequireFields<SOstoslistaQueryShoppingListArgs, 'id'>>;
  shoppingLists: Resolver<Array<SOstoslistaResolversTypes['ShoppingList']>, ParentType, ContextType>;
  store: Resolver<SOstoslistaResolversTypes['StoreInfo'], ParentType, ContextType, RequireFields<SOstoslistaQueryStoreArgs, 'id'>>;
  stores: Resolver<SOstoslistaResolversTypes['SearchStoresResponse'], ParentType, ContextType, Partial<SOstoslistaQueryStoresArgs>>;
  user: Resolver<Maybe<SOstoslistaResolversTypes['User']>, ParentType, ContextType>;
};

export type SOstoslistaRecipeResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Recipe'] = SOstoslistaResolversParentTypes['Recipe']> = {
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  imageUrl: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  notes: Resolver<Maybe<Array<SOstoslistaResolversTypes['RecipeNote']>>, ParentType, ContextType>;
  products: Resolver<Array<SOstoslistaResolversTypes['RecipeProduct']>, ParentType, ContextType>;
  title: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  url: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaRecipeNoteResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['RecipeNote'] = SOstoslistaResolversParentTypes['RecipeNote']> = {
  content: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaRecipeProductResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['RecipeProduct'] = SOstoslistaResolversParentTypes['RecipeProduct']> = {
  ean: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  quantity: Resolver<SOstoslistaResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaSearchRecipesResponseResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['SearchRecipesResponse'] = SOstoslistaResolversParentTypes['SearchRecipesResponse']> = {
  items: Resolver<Array<SOstoslistaResolversTypes['Recipe']>, ParentType, ContextType>;
  maybeHasMore: Resolver<SOstoslistaResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaSearchStoresResponseResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['SearchStoresResponse'] = SOstoslistaResolversParentTypes['SearchStoresResponse']> = {
  cursor: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  maybeHasMore: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  stores: Resolver<Array<SOstoslistaResolversTypes['StoreInfo']>, ParentType, ContextType>;
  totalCount: Resolver<SOstoslistaResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaSharedShoppingListLinkResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['SharedShoppingListLink'] = SOstoslistaResolversParentTypes['SharedShoppingListLink']> = {
  id: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaShoppingListResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ShoppingList'] = SOstoslistaResolversParentTypes['ShoppingList']> = {
  createdAt: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  items: Resolver<Array<SOstoslistaResolversTypes['IShoppingListItem']>, ParentType, ContextType>;
  modifiedAt: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  permissions: Resolver<Array<SOstoslistaResolversTypes['Permission']>, ParentType, ContextType>;
  shared: Resolver<SOstoslistaResolversTypes['Boolean'], ParentType, ContextType>;
  storeId: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaShoppingListItemResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['ShoppingListItem'] = SOstoslistaResolversParentTypes['ShoppingListItem']> = {
  collected: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  name: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  shoppingListId: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreAddressResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreAddress'] = SOstoslistaResolversParentTypes['StoreAddress']> = {
  country: Resolver<Maybe<SOstoslistaResolversTypes['Country']>, ParentType, ContextType>;
  municipality: Resolver<SOstoslistaResolversTypes['Municipality'], ParentType, ContextType>;
  postcode: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  postcodeName: Resolver<Maybe<SOstoslistaResolversTypes['LocalizableText']>, ParentType, ContextType>;
  street: Resolver<SOstoslistaResolversTypes['LocalizableText'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreContactInfoResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreContactInfo'] = SOstoslistaResolversParentTypes['StoreContactInfo']> = {
  email: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber: Resolver<Maybe<SOstoslistaResolversTypes['StorePhoneNumber']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreDayOpeningTimeResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreDayOpeningTime'] = SOstoslistaResolversParentTypes['StoreDayOpeningTime']> = {
  date: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  day: Resolver<SOstoslistaResolversTypes['DayLabel'], ParentType, ContextType>;
  exceptional: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  message: Resolver<Maybe<SOstoslistaResolversTypes['LocalizedText']>, ParentType, ContextType>;
  mode: Resolver<SOstoslistaResolversTypes['StoreOpeningTimeRangeLabel'], ParentType, ContextType>;
  ranges: Resolver<Maybe<Array<SOstoslistaResolversTypes['StoreOpeningTimeRange']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreFeedbackResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreFeedback'] = SOstoslistaResolversParentTypes['StoreFeedback']> = {
  url: Resolver<Maybe<SOstoslistaResolversTypes['LocalizableText']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreInfoResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreInfo'] = SOstoslistaResolversParentTypes['StoreInfo']> = {
  availablePaymentMethods: Resolver<Maybe<Array<SOstoslistaResolversTypes['PaymentMethod']>>, ParentType, ContextType>;
  brand: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  city: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  contactInfo: Resolver<Maybe<SOstoslistaResolversTypes['StoreContactInfo']>, ParentType, ContextType>;
  distance: Resolver<Maybe<SOstoslistaResolversTypes['Float']>, ParentType, ContextType>;
  domains: Resolver<Array<SOstoslistaResolversTypes['Domain']>, ParentType, ContextType>;
  feedback: Resolver<Maybe<SOstoslistaResolversTypes['StoreFeedback']>, ParentType, ContextType>;
  id: Resolver<SOstoslistaResolversTypes['ID'], ParentType, ContextType>;
  location: Resolver<Maybe<SOstoslistaResolversTypes['StoreLocation']>, ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  postalCode: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  services: Resolver<Maybe<Array<SOstoslistaResolversTypes['StoreService']>>, ParentType, ContextType>;
  shortName: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  street: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  weeklyOpeningHours: Resolver<Maybe<Array<SOstoslistaResolversTypes['StoreWeeklyOpeningTime']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreLocationResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreLocation'] = SOstoslistaResolversParentTypes['StoreLocation']> = {
  address: Resolver<Maybe<SOstoslistaResolversTypes['StoreAddress']>, ParentType, ContextType>;
  coordinates: Resolver<Maybe<SOstoslistaResolversTypes['Coordinates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreOpeningTimeRangeResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreOpeningTimeRange'] = SOstoslistaResolversParentTypes['StoreOpeningTimeRange']> = {
  close: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  closeOnSameDay: Resolver<Maybe<SOstoslistaResolversTypes['Boolean']>, ParentType, ContextType>;
  open: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStorePhoneNumberResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StorePhoneNumber'] = SOstoslistaResolversParentTypes['StorePhoneNumber']> = {
  callCharge: Resolver<Maybe<SOstoslistaResolversTypes['LocalizableText']>, ParentType, ContextType>;
  callChargeGroup: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  number: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreServiceResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreService'] = SOstoslistaResolversParentTypes['StoreService']> = {
  code: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['LocalizableText']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaStoreWeeklyOpeningTimeResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['StoreWeeklyOpeningTime'] = SOstoslistaResolversParentTypes['StoreWeeklyOpeningTime']> = {
  openingTimes: Resolver<Array<SOstoslistaResolversTypes['StoreDayOpeningTime']>, ParentType, ContextType>;
  weekNumber: Resolver<SOstoslistaResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaSubscriptionResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['Subscription'] = SOstoslistaResolversParentTypes['Subscription']> = {
  updatedShoppingList: SubscriptionResolver<Maybe<SOstoslistaResolversTypes['ShoppingList']>, "updatedShoppingList", ParentType, ContextType, RequireFields<SOstoslistaSubscriptionUpdatedShoppingListArgs, 'id'>>;
  updatedShoppingListItem: SubscriptionResolver<Maybe<SOstoslistaResolversTypes['IShoppingListItem']>, "updatedShoppingListItem", ParentType, ContextType, RequireFields<SOstoslistaSubscriptionUpdatedShoppingListItemArgs, 'shoppingListId'>>;
};

export type SOstoslistaUserResolvers<ContextType = Context, ParentType extends SOstoslistaResolversParentTypes['User'] = SOstoslistaResolversParentTypes['User']> = {
  id: Resolver<SOstoslistaResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<Maybe<SOstoslistaResolversTypes['String']>, ParentType, ContextType>;
  type: Resolver<SOstoslistaResolversTypes['UserType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SOstoslistaResolvers<ContextType = Context> = {
  Allergen: SOstoslistaAllergenResolvers<ContextType>;
  Coordinates: SOstoslistaCoordinatesResolvers<ContextType>;
  Country: SOstoslistaCountryResolvers<ContextType>;
  CountryName: SOstoslistaCountryNameResolvers<ContextType>;
  HierarchyPathItem: SOstoslistaHierarchyPathItemResolvers<ContextType>;
  IDObject: SOstoslistaIdObjectResolvers<ContextType>;
  IShoppingListItem: SOstoslistaIShoppingListItemResolvers<ContextType>;
  LocalizableText: SOstoslistaLocalizableTextResolvers<ContextType>;
  LocalizedText: SOstoslistaLocalizedTextResolvers<ContextType>;
  Municipality: SOstoslistaMunicipalityResolvers<ContextType>;
  Mutation: SOstoslistaMutationResolvers<ContextType>;
  Navigation: SOstoslistaNavigationResolvers<ContextType>;
  NavigationItem: SOstoslistaNavigationItemResolvers<ContextType>;
  Nutrient: SOstoslistaNutrientResolvers<ContextType>;
  Product: SOstoslistaProductResolvers<ContextType>;
  ProductLocation: SOstoslistaProductLocationResolvers<ContextType>;
  ProductMeasurement: SOstoslistaProductMeasurementResolvers<ContextType>;
  ProductPricing: SOstoslistaProductPricingResolvers<ContextType>;
  ProductResolvedShoppingListItem: SOstoslistaProductResolvedShoppingListItemResolvers<ContextType>;
  ProductSearchResult: SOstoslistaProductSearchResultResolvers<ContextType>;
  Query: SOstoslistaQueryResolvers<ContextType>;
  Recipe: SOstoslistaRecipeResolvers<ContextType>;
  RecipeNote: SOstoslistaRecipeNoteResolvers<ContextType>;
  RecipeProduct: SOstoslistaRecipeProductResolvers<ContextType>;
  SearchRecipesResponse: SOstoslistaSearchRecipesResponseResolvers<ContextType>;
  SearchStoresResponse: SOstoslistaSearchStoresResponseResolvers<ContextType>;
  SharedShoppingListLink: SOstoslistaSharedShoppingListLinkResolvers<ContextType>;
  ShoppingList: SOstoslistaShoppingListResolvers<ContextType>;
  ShoppingListItem: SOstoslistaShoppingListItemResolvers<ContextType>;
  StoreAddress: SOstoslistaStoreAddressResolvers<ContextType>;
  StoreContactInfo: SOstoslistaStoreContactInfoResolvers<ContextType>;
  StoreDayOpeningTime: SOstoslistaStoreDayOpeningTimeResolvers<ContextType>;
  StoreFeedback: SOstoslistaStoreFeedbackResolvers<ContextType>;
  StoreInfo: SOstoslistaStoreInfoResolvers<ContextType>;
  StoreLocation: SOstoslistaStoreLocationResolvers<ContextType>;
  StoreOpeningTimeRange: SOstoslistaStoreOpeningTimeRangeResolvers<ContextType>;
  StorePhoneNumber: SOstoslistaStorePhoneNumberResolvers<ContextType>;
  StoreService: SOstoslistaStoreServiceResolvers<ContextType>;
  StoreWeeklyOpeningTime: SOstoslistaStoreWeeklyOpeningTimeResolvers<ContextType>;
  Subscription: SOstoslistaSubscriptionResolvers<ContextType>;
  User: SOstoslistaUserResolvers<ContextType>;
};

export type SOstoslistaDirectiveResolvers<ContextType = Context> = {
  aws_api_key: SOstoslistaAws_Api_KeyDirectiveResolver<any, any, ContextType>;
  aws_auth: SOstoslistaAws_AuthDirectiveResolver<any, any, ContextType>;
  aws_cognito_user_pools: SOstoslistaAws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam: SOstoslistaAws_IamDirectiveResolver<any, any, ContextType>;
  aws_lambda: SOstoslistaAws_LambdaDirectiveResolver<any, any, ContextType>;
  aws_oidc: SOstoslistaAws_OidcDirectiveResolver<any, any, ContextType>;
  aws_publish: SOstoslistaAws_PublishDirectiveResolver<any, any, ContextType>;
  aws_subscribe: SOstoslistaAws_SubscribeDirectiveResolver<any, any, ContextType>;
  defer: SOstoslistaDeferDirectiveResolver<any, any, ContextType>;
};


import { gql } from "@apollo/client/core"
export const typeDefs = gql`schema{query:Query mutation:Mutation subscription:Subscription}"Tells the service this field/object has access authorized by an API key." directive@aws_api_key on FIELD_DEFINITION|OBJECT "Directs the schema to enforce authorization on a field" directive@aws_auth("""List of cognito user pool groups which have access on this field""" cognito_groups:[String])on FIELD_DEFINITION "Tells the service this field/object has access authorized by a Cognito User Pools token." directive@aws_cognito_user_pools("""List of cognito user pool groups which have access on this field""" cognito_groups:[String])on FIELD_DEFINITION|OBJECT "Tells the service this field/object has access authorized by sigv4 signing." directive@aws_iam on FIELD_DEFINITION|OBJECT "Tells the service this field/object has access authorized by a Lambda Authorizer." directive@aws_lambda on FIELD_DEFINITION|OBJECT "Tells the service this field/object has access authorized by an OIDC token." directive@aws_oidc on FIELD_DEFINITION|OBJECT "Tells the service which subscriptions will be published to when this mutation is called. This directive is deprecated use @aws_susbscribe directive instead." directive@aws_publish("""List of subscriptions which will be published to when this mutation is called.""" subscriptions:[String])on FIELD_DEFINITION "Tells the service which mutation triggers this subscription." directive@aws_subscribe("""List of mutations which will trigger this subscription when they are called.""" mutations:[String])on FIELD_DEFINITION "This directive allows results to be deferred during execution" directive@defer on FIELD type Allergen{allergenTypeCode:String allergenTypeText:String levelOfContainmentCode:String}enum CacheControlScope{PRIVATE PUBLIC}type Coordinates{lat:String!lon:String!}input CoordinatesInput{lat:Float!lon:Float!}type Country{code:String!}type CountryName{fi:String}input CreateProductResolvedShoppingListItemInput{collected:Boolean commentForPicker:String ean:String!isReplaceable:Boolean!name:String!quantity:Float!quantityUnit:String!sokId:String!}input CreateShoppingListItemInput{collected:Boolean name:String!}enum DayLabel{FRI MON SAT SUN THU TUE WED}enum Domain{ABC EPRISMA HERKKU S_KAUPAT}type HierarchyPathItem{hidden:Boolean!id:String!name:String!slug:String!}type IDObject{id:ID!}interface IShoppingListItem{collected:Boolean id:ID!name:String!shoppingListId:String!}input InsertByEanInput{ean:String!quantity:Float!}type LocalizableText{default:String!en:String et:String fi:String sv:String}type LocalizedText{en:String et:String fi:String sv:String}type Municipality{code:String!name:LocalizableText}type Mutation{batchDeleteShoppingListItem(ids:[ID!]!shoppingListId:ID!):ShoppingList!batchInsertByEan(items:[InsertByEanInput!]!shoppingListId:ID!):ShoppingList!batchInsertShoppingListItem(items:[CreateShoppingListItemInput!]productResolvedItems:[CreateProductResolvedShoppingListItemInput!]shoppingListId:ID!):ShoppingList!batchUpdateShoppingListItem(ids:[ID!]!items:[UpdateShoppingListItemInput!]!shoppingListId:ID!):ShoppingList!claimSharedShoppingList(linkId:ID!):ShoppingList!createProductResolvedShoppingListItem(item:CreateProductResolvedShoppingListItemInput!shoppingListId:ID!):ShoppingList!createShoppingList(items:[CreateShoppingListItemInput!]name:String!productResolvedItems:[CreateProductResolvedShoppingListItemInput!]storeId:String):ShoppingList createShoppingListFromRecipe(name:String!recipeId:String!storeId:String):ShoppingList createShoppingListItem(item:CreateShoppingListItemInput!shoppingListId:ID!):ShoppingList!deleteShoppingList(id:ID!):IDObject!deleteShoppingListItem(id:ID!shoppingListId:ID!):ShoppingList!duplicateShoppingList(id:ID!name:String!storeId:String):ShoppingList!generateShoppingListShareLink(id:ID!permissions:[Permission!]!validForHours:Int):SharedShoppingListLink!insertRecipeProductsToList(recipeId:String!shoppingListId:ID!):ShoppingList!resolveShoppingListItemProduct(id:ID!shoppingListId:ID!sokId:String!):ShoppingList!setListItemsReplaceability(isReplaceable:Boolean!shoppingListId:ID!):ShoppingList!unresolveShoppingListItemProduct(id:ID!shoppingListId:ID!):ShoppingList!updateShoppingList(id:ID!name:String storeId:String):ShoppingList!updateShoppingListItem(id:ID!item:UpdateShoppingListItemInput!shoppingListId:ID!):IShoppingListItem!}type Navigation{navigation:[NavigationItem!]}type NavigationItem{children:[NavigationItem!]hidden:Boolean id:String itemCount:Int name:String sequence:String slug:String type:String}type Nutrient{kcal:Float kj:Float name:String ri:String value:String}enum PaymentMethod{CARD_PAYMENT INVOICE ON_DELIVERY}enum Permission{READ SHARE WRITE}type Product{_lemmasAliasName:String _lemmasDescription:String _lemmasHierarchyLeaf:String _lemmasName:String allergens:[Allergen!]approxPrice:Boolean available:Boolean!basicQuantityUnit:String brandName:String category:String comparisonPrice:Float comparisonUnit:String countryName:CountryName depositPrice:Float description:String!ean:String!frozen:Boolean hierarchyPath:[HierarchyPathItem!]id:ID!ingredientStatement:String isAgeLimitedByAlcohol:Boolean isGlobalFallback:Boolean location:ProductLocation measurement:ProductMeasurement name:String!nutrients:[Nutrient!]packagingLabelCodes:[String!]packagingLabels:[String!]price:Float priceUnit:String!pricing:ProductPricing quantityMultiplier:Float storeId:ID storeInfo(pageSize:Int userLocation:CoordinatesInput):[StoreInfo!]supplierName:String}enum ProductDataSource{S_KAUPAT S_OSTOSLISTA}type ProductLocation{aisle:String floor:Int!label:String name:String}type ProductMeasurement{grossWeight:Float grossWeightUnit:String netWeight:Float netWeightUnit:String pceApproxWeight:Float}type ProductPricing{campaignPrice:Float campaignPriceValidUntil:String comparisonPrice:Float!currentPrice:Float!depositPrice:Float lowest30DayPrice:Float regularPrice:Float!}type ProductResolvedShoppingListItem implements IShoppingListItem{collected:Boolean commentForPicker:String ean:String!id:ID!isReplaceable:Boolean!name:String!product(dataSource:ProductDataSource storeId:String):Product quantity:Float!quantityUnit:String!shoppingListId:String!sokId:String!}type ProductSearchResult{items:[Product!]!maybeHasMore:Boolean!}type Query{anonymousUserToken:String!navigation(storeId:ID!):[NavigationItem!]product(globalAssortment:Boolean id:ID!storeId:ID):Product!productByEan(ean:ID!globalAssortment:Boolean storeId:ID):Product!products(eans:[String!]excludedCdts:[String!]from:Int globalAssortment:Boolean ids:[ID!]includedCdts:[String!]pageSize:Int query:String storeId:ID):ProductSearchResult!recipes(from:Int pageSize:Int query:String!):SearchRecipesResponse!shoppingList(id:ID!):ShoppingList!shoppingLists:[ShoppingList!]!store(id:ID!):StoreInfo!stores(brand:StoreBrand cursor:String pageSize:Int query:String):SearchStoresResponse!user:User}type Recipe{id:ID!imageUrl:String notes:[RecipeNote!]products:[RecipeProduct!]!title:String!url:String!}type RecipeNote{content:String!}type RecipeProduct{ean:String!quantity:Float!}type SearchRecipesResponse{items:[Recipe!]!maybeHasMore:Boolean!}type SearchStoresResponse{cursor:String maybeHasMore:Boolean stores:[StoreInfo!]!totalCount:Int!}type SharedShoppingListLink{id:String!}type ShoppingList{createdAt:String!id:ID!items:[IShoppingListItem!]!modifiedAt:String!name:String!permissions:[Permission!]!shared:Boolean!storeId:String}type ShoppingListItem implements IShoppingListItem{collected:Boolean id:ID!name:String!shoppingListId:String!}type StoreAddress{country:Country municipality:Municipality!postcode:String!postcodeName:LocalizableText street:LocalizableText!}enum StoreBrand{ABC ALEPA HERKKU MESTARIN_HERKKU PRISMA SALE SOKOS_HERKKU S_MARKET}type StoreContactInfo{email:String phoneNumber:StorePhoneNumber}type StoreDayOpeningTime{date:String!day:DayLabel!exceptional:Boolean message:LocalizedText mode:StoreOpeningTimeRangeLabel!ranges:[StoreOpeningTimeRange!]}type StoreFeedback{url:LocalizableText}type StoreInfo{availablePaymentMethods:[PaymentMethod!]brand:String city:String contactInfo:StoreContactInfo distance:Float domains:[Domain!]!feedback:StoreFeedback id:ID!location:StoreLocation name:String postalCode:String services:[StoreService!]shortName:String street:String weeklyOpeningHours:[StoreWeeklyOpeningTime!]}type StoreLocation{address:StoreAddress coordinates:Coordinates}type StoreOpeningTimeRange{close:String!closeOnSameDay:Boolean open:String!}enum StoreOpeningTimeRangeLabel{ALL_DAY BY_RESERVATION CLOSED RANGE}type StorePhoneNumber{callCharge:LocalizableText callChargeGroup:String number:String!}type StoreService{code:String!name:LocalizableText}type StoreWeeklyOpeningTime{openingTimes:[StoreDayOpeningTime!]!weekNumber:Int!}type Subscription{updatedShoppingList(id:ID!):ShoppingList updatedShoppingListItem(shoppingListId:String!):IShoppingListItem}input UpdateShoppingListItemInput{collected:Boolean commentForPicker:String isReplaceable:Boolean name:String quantity:Float}type User{id:String!name:String type:UserType!}enum UserType{ANONYMOUS_USER}`;
